define('modules/editor/views/elements/text',['require','exports','module','./element'],function(require, exports, module){
  "use strict";
  var Element = require("./element");
  module.exports = Element.extend({
    className: "ed-panel-item ed-item-textblock editor-item-textblock",

    events: _.extend(Element.prototype.events, {
      "click a": "preventDefault"
    }),

    onEditContent: function() {
      this.model.editText();
    },

    preventDefault: function(e) {
      e.preventDefault();
      e.stopPropagation();

      return false;
    }
  });
});

